import { render, staticRenderFns } from "./manyAreaSetting.vue?vue&type=template&id=22501f4a&scoped=true&"
import script from "./manyAreaSetting.vue?vue&type=script&lang=js&"
export * from "./manyAreaSetting.vue?vue&type=script&lang=js&"
import style0 from "./manyAreaSetting.vue?vue&type=style&index=0&id=22501f4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22501f4a",
  null
  
)

export default component.exports